import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import { useContext, useState } from "react";
import ModalDeleteDokumen from "../components/ModalDeleteDokumen";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useDokumen } from "../../../Context/DokumenContext";

const DaftarColumns = (getDokumenList) => {
  const dokumenAPI = useDokumen();
  const { checkPermission } = useContext(RoleContext);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(null);
  const toggleDropdown = (id) =>
    setDropdownOpen(dropdownOpen === id ? null : id);
  const toggleDelete = (id) => setDeleteOpen(deleteOpen === id ? null : id);

  const handleDownloadDokumen = (id) => {
    dokumenAPI.getFile(id);
  };

  return [
    {
      name: <DataTableTitle text={"ID"} />,
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Judul"} />,
      selector: (row) => row.judul,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Deskripsi"} />,
      selector: (row) => row.deskripsi,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Dokumen"} />,
      width: "20%",
      cell: (row) => (
        <>
          <Dropdown
            toggle={() => toggleDropdown(row.id)}
            isOpen={dropdownOpen === row.id}
          >
            <DropdownToggle>&#9660;</DropdownToggle>
            <DropdownMenu>
              <DropdownItem style={{color: '#000'}} onClick={() => handleDownloadDokumen(row.id)}>
                Download
              </DropdownItem>
              {checkPermission(PERMISSIONS.DELETE_DOKUMEN) && (
                <DropdownItem style={{color: '#000'}} onClick={() => toggleDelete(row.id)}>
                  Hapus
                </DropdownItem>
              )}
            </DropdownMenu>
          </Dropdown>
          <ModalDeleteDokumen
            data={row}
            resetState={getDokumenList}
            toggle={toggleDelete}
            isOpen={row.id === deleteOpen}
          />
        </>
      ),
    },
  ];
};

export default DaftarColumns;
